/**
 * Representation of a component metadata.
 */
class ComponentMetadata {
    constructor(options) {
        this.api = options.api;
        this.component = options.component;
        this.containers = options.containers;
        this.deprecated = options.deprecated;
        this.description = options.description;
        this.name = options.name;
        this.properties = options.properties;
        this.type = options.type;
    }
    // @ts-ignore: Check the comment at the top of the file for the explanation on why.
    getAPI() {
        return this.api;
    }
    getComponent() {
        return this.component;
    }
    getContainers() {
        return this.containers;
    }
    isDeprecated() {
        return Boolean(this.deprecated);
    }
    getDescription() {
        return this.description;
    }
    getName() {
        return this.name;
    }
    getProperties() {
        return this.properties;
    }
    getPropTypes() {
        const renderable = this.getComponent();
        if (renderable.propTypes) {
            return renderable.propTypes;
        }
        const propTypes = {};
        for (const [key, value] of Object.entries(this.getProperties() ?? {})) {
            propTypes[key] = value.type;
        }
        return propTypes;
    }
    getDefaultProps() {
        const renderable = this.getComponent();
        if (renderable.defaultProps) {
            return renderable.defaultProps;
        }
        const defaultProps = {};
        for (const [key, value] of Object.entries(this.getProperties() ?? {})) {
            if (Object.prototype.hasOwnProperty.call(value, 'defaultValue')) {
                defaultProps[key] = value.defaultValue;
            }
        }
        return defaultProps;
    }
    getType() {
        return this.type;
    }
}
export { ComponentMetadata, };
//# sourceMappingURL=component-metadata.js.map